// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"328":"ChatBot","589":"ValueCompendium","924":"Pico"}[chunkId] || chunkId) + "." + {"203":"ca86a229","328":"9b9f493e","589":"d14f438d","891":"0acecf7f","924":"b0beee9d","940":"490dc46a"}[chunkId] + ".chunk.js";
};